import { defaultConfigs } from "./configuration.js";
import { PulseModule } from "./di/module.js";
import { coreProviders } from "./providers/index.js";
function buildConfig(userConfig) {
    const config = {
        ...defaultConfigs,
        ...userConfig,
    };
    if (config.mode !== 'standard') {
        config.hashStoreStorageType = 'memory';
    }
    return config;
}
export const CoreModule = new PulseModule().provide(coreProviders).beforeInit(buildConfig);
//# sourceMappingURL=core.module.js.map